import * as React from "react";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsAiAssistantTemplatesNew from "./SectionsSettingsAiAssistantTemplatesNew";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionsSettingsAiAssistantTemplatesNewPage: React.FC<Props> = (
  props,
) => {
  React.useEffect(() => {
    props.setActiveMenu("template");
  }, []);

  return <SectionsSettingsAiAssistantTemplatesNew section={props.section} />;
};

const pageInfo = {
  title: "テンプレート",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsAiAssistantTemplatesNewPage,
  pageInfo,
);
